var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"owal-tagging-header__container"},[_c('cotenants',{attrs:{"cotenants":_vm.cotenants,"tenant":_vm.selectedProfile,"badges":_vm.badges,"selection-mode":"single"},on:{"click":_vm.handleClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }